const files = require.context('.', false, /\.js$/);
const modules = [];

files.keys().forEach((key) => {
  // disable surveys paths
  if (key === './index.js' || key === './surveysFeature.js') return;
  modules.push(...files(key).default);
});

export default modules;
